require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-idb-consultations-on-the-environmental-and-social-policy.json") })
        }
      }, "path---en-us-update-idb-consultations-on-the-environmental-and-social-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-idb-consultations-on-the-environmental-and-social-policy!./.cache/json/en-us-update-idb-consultations-on-the-environmental-and-social-policy.json
// module id = 747
// module chunks = 231608221292675